import { MaskedFieldVariant } from '../MaskedField';

export const getMask = (variant: MaskedFieldVariant) => {
  switch (variant) {
    case 'ssn': {
      return '###{-}##{-}0000';
    }
    case 'sin': {
      return '###{-}###{-}000';
    }
    case 'phone': {
      return '+{1 }{(}000{)}000{-}0000';
    }
  }
};
